import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { CustomField } from 'types';

type UpdateCustomFieldData = {
  name?: string;
  description?: string;
  type?: CustomField['type'];
  required?: boolean;
  options?: string[];
  defaultValue?: unknown;
};

const updateCustomField = async (
  customFieldId: string,
  updateData: UpdateCustomFieldData
): Promise<CustomField> => {
  const response = await customAxios.patch<CustomField>(
    `/custom-fields/${customFieldId}`,
    updateData
  );
  return response.data;
};

export const useUpdateCustomField = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      customFieldId,
      updateData,
    }: {
      customFieldId: string;
      updateData: UpdateCustomFieldData;
    }) => updateCustomField(customFieldId, updateData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['custom-fields', orgId] }).catch(() => undefined);
    },
  });
};
